"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RowItem = exports.TagItem = void 0;
const material_1 = require("@mui/material");
const styled_components_1 = __importStar(require("styled-components"));
const tagColor = (tag, isIndividualPermissionTag) => {
    const colorMap = {
        PRZYZNANO: isIndividualPermissionTag ? '#c8ebca' : '#f9f9f9',
        BRAK: isIndividualPermissionTag ? '#ffe6e6' : '#f9f9f9',
        NIEZDEFINIOWANO: '#f9f9f9',
        BRAK_INDYWIDUALNE: '#ffe6e6',
        PRZYZNANO_INDYWIDUALNE: '#c8ebca',
        PERSONALNA: '#dbe8ff',
        STRUKTURALNA: '#e0e3a2',
        ADMINISTRATOR: '#dbe8ff',
        ZWYKLY: '#e0e3a2',
    };
    // Handle corrupted enum values gracefully
    if (tag.includes('STRUKTURALNA')) {
        return colorMap.STRUKTURALNA;
    }
    if (tag.includes('PERSONALNA')) {
        return colorMap.PERSONALNA;
    }
    // Return mapped color or default
    return colorMap[tag] || '#f0f0f0'; // Default gray for unknown tags
};
exports.TagItem = (0, styled_components_1.default)(material_1.Typography)(({ $tag, $isIndividualPermissionTag }) => (0, styled_components_1.css) `
    background-color: ${tagColor($tag, $isIndividualPermissionTag)};
    padding: 6px 16px;
    font-weight: 600 !important;
    margin-right: 9px;
    border-radius: 16px;
    display: inline-block;
    max-width: 170px;
    line-height: 1;
  `);
exports.RowItem = styled_components_1.default.span `
  padding: 0 17px;
`;
